<div class="loading-overlay" [class.full-height]="fullHeight" [class.as-overlay]="overlay">
  <p-progressSpinner styleClass="loading-spinner"></p-progressSpinner>
  @if (message) {
    <span class="loading-text">{{ message }}</span>
  }
</div>


